import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { DatePicker, Row, Col, Typography, Button } from "antd";
import dayjs from "dayjs";
import { CustomTable } from "../utils/CustomComponents";
import axios from "axios";
import { api } from "../utils/Api";
import * as XLSX from "xlsx";

const { RangePicker } = DatePicker;
const { Text } = Typography;

const ReportTrips2 = () => {
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [loading, setLoading] = useState(true);
	const [singleDriverData, setSingleDriverData] = useState([]);
	const [allDriverData, setAllDriverData] = useState([]);
	const [columnsAllDrivers, setColumnsAllDrivers] = useState([]);
	const [daysBetween, setDaysBetween] = useState([]);

	useEffect(() => {
		getLoads();
	}, [startDate, endDate]);

	const getLoads = async () => {
		const initDate = startDate.startOf("week").set("day", 1);
		const lastDate = endDate.endOf("week").set("day", 7);

		const start = `${initDate.year()}-${
			initDate.month() + 1
		}-${initDate.date()}`;
		const end = `${lastDate.year()}-${lastDate.month() + 1}-${lastDate.date()}`;

		const url =
			api + `/loadgroupdate2/57Concrete?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			generateDataCountDriverSingle(data);
			generateDataCountDriverAll(data);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const generateDataCountDriverSingle = (data) => {
		let mapObj = {};
		data.map((item) => {
			const itemDate = dayjs(
				`${item._id.year}-${item._id.month}-${item._id.day}`
			);
			if (
				(itemDate.isAfter(startDate.startOf("day")) ||
					itemDate.isSame(startDate.startOf("day"))) &&
				(itemDate.isBefore(endDate.endOf("day")) ||
					itemDate.isSame(endDate.endOf("day")))
			) {
				if (!mapObj[item._id.driver]) {
					mapObj[item._id.driver] = item.count;
				} else {
					mapObj[item._id.driver] += item.count;
				}
			}
		});

		let itemCountDriver = [];
		Object.entries(mapObj).map(([key, value]) => {
			itemCountDriver.push({
				key: key,
				driver: key,
				loads: value,
			});
		});

		const orderedDriverData = itemCountDriver.sort((a, b) => {
			return a.driver.localeCompare(b.driver);
		});

		setSingleDriverData(orderedDriverData);
	};

	const generateDataCountDriverAll = (data) => {
		let initDate = startDate.startOf("week").set("day", 1);
		const lastDate = endDate.endOf("week").set("day", 7);
		const daysBetween = [];

		let columns = [
			{
				title: "Driver",
				dataIndex: "driver",
				key: "driver",
				onCell: () => ({
					style: {
						width: 200,
						minWidth: 200,
						maxWidth: 200,
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
					},
				}),
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
		];

		while (
			initDate.isBefore(lastDate, "day") ||
			initDate.isSame(lastDate, "day")
		) {
			const dataKey = initDate.format("MM/DD/YYYY");
			const day = initDate.format("dddd");
			daysBetween.push(dataKey);
			columns.push({
				title: () => {
					return (
						<Row gutter={[16, 8]}>
							<Col span={24}>{day}</Col>
							<Col span={24}>{dataKey}</Col>
						</Row>
					);
				},
				dataIndex: dataKey,
				key: dataKey,
				onCell: (record) => {
					const currentValue = record[dataKey];
					return {
						style: {
							backgroundColor: currentValue === undefined ? "red" : undefined,
						},
					};
				},
				render: (value) => {
					const currentValue = value || 0;
					return (
						<Text style={{ color: currentValue === 0 ? "white" : "black" }}>
							{currentValue}
						</Text>
					);
				},
			});
			initDate = initDate.add(1, "day");
		}
		columns.push({
			title: "Total",
			dataIndex: "total",
			key: "total",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		});
		setDaysBetween(daysBetween);
		setColumnsAllDrivers(columns);

		let dataDriverAll = {};

		daysBetween.map((day) => {
			const currentDate = dayjs(day);
			data.map((item) => {
				const itemDate = dayjs(
					`${item._id.year}-${item._id.month}-${item._id.day}`
				);
				if (itemDate.isSame(currentDate)) {
					if (!dataDriverAll[item._id.driver]) {
						dataDriverAll[item._id.driver] = {
							[day]: item.count,
						};
					} else {
						dataDriverAll[item._id.driver] = {
							...dataDriverAll[item._id.driver],
							[day]: item.count,
						};
					}
				}
			});
		});

		let data2 = [];
		Object.entries(dataDriverAll).map(([key, value], index) => {
			let newRow = {
				key: index,
				driver: key,
			};
			let total = 0;
			Object.entries(value).map(([key2, value2]) => {
				newRow[key2] = value2;
				total += value2;
			});
			newRow.total = total;
			data2.push(newRow);
		});

		const orderedDriverData = data2.sort((a, b) => {
			return a.driver.localeCompare(b.driver);
		});

		setAllDriverData(orderedDriverData);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setLoading(true);
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderDates = () => (
		<RangePicker
			defaultValue={[
				dayjs(startDate, "MM/DD/YYYY"),
				dayjs(endDate, "MM/DD/YYYY"),
			]}
			onChange={onRangeChange}
			format={"MM/DD/YYYY"}
			size="large"
			disabled={loading}
			allowClear={false}
		/>
	);

	const columnsCountLoads = [
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: () => {
				const initDate = Intl.DateTimeFormat("en-US").format(
					startDate.toDate()
				);
				const lastDate = Intl.DateTimeFormat("en-US").format(endDate.toDate());
				return (
					<Row gutter={[16, 16]}>
						<Col span={24}>Total Loads in Date Range</Col>
						<Col span={24}>{`${initDate}-${lastDate}`}</Col>
					</Row>
				);
			},
			dataIndex: "loads",
			key: "loads",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	const RenderTableSingle = () => (
		<CustomTable
			loading={loading}
			columns={columnsCountLoads}
			data={singleDriverData}
			isScroll={false}
		/>
	);

	const RenderTableAll = () => (
		<CustomTable
			loading={loading}
			columns={columnsAllDrivers}
			data={allDriverData}
			isScroll={true}
		/>
	);

	const handleDownload = () => {
		const wb = XLSX.utils.book_new();

		const customHeadersSheet1 = ["Driver", "Loads"];
		const formattedSheet1 = singleDriverData.map(({ driver, loads }) => ({
			Driver: driver,
			Loads: loads,
		}));
		const ws1 = XLSX.utils.json_to_sheet(formattedSheet1, {
			header: customHeadersSheet1,
		});

		const customHeadersSheet2 = [
			"Driver",
			...daysBetween.map((i) => i),
			"Total",
		];
		const formattedSheet2 = allDriverData.map(
			({ driver, total, key, ...res }) => ({
				Driver: driver,
				...res,
				Total: total,
			})
		);
		const ws2 = XLSX.utils.json_to_sheet(formattedSheet2, {
			header: customHeadersSheet2,
		});

		XLSX.utils.book_append_sheet(wb, ws1, "Loads per Driver in Date Range");
		XLSX.utils.book_append_sheet(wb, ws2, "Loads per Driver in Weeks");

		XLSX.writeFile(wb, "57concrete-trips-report.xlsx");
	};

	return (
		<Layout title="Trips Report by Driver" description="Report">
			<Row gutter={[16, 16]} justify={"center"} align={"middle"}>
				<Col span={24}>
					<RenderDates />
				</Col>
				<Col span={24}>
					<Button
						type="primary"
						size="large"
						onClick={handleDownload}
						loading={loading}
						disabled={loading}
					>
						Download Report
					</Button>
				</Col>
				<Col span={8}>
					<RenderTableSingle />
				</Col>
				<Col span={24}>
					<RenderTableAll />
				</Col>
			</Row>
		</Layout>
	);
};

export default ReportTrips2;
